import React, { useState } from 'react';
import { Table as HefestoTable } from '@gerdau/hefesto-mais-web';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import {
  EProvideWireQuantityTypes,
  IExtraItensState
} from '../../../../../store/ducks/fabrication-purchase-order/types';
import CheckoutTableHeader from '../CheckoutTableHeader';
import { CheckoutContainer, TableContainer } from '../styles';

interface FabricationCheckoutWireTableDataSource {
  key: number;
  wireType: string;
  quantityBy: string;
  wireWeight: string;
  percentage: string;
}

interface IWireTableProps {
  goToExtraItens(): void;
  extraItens: IExtraItensState;
  isGeneratingPdf?: boolean;
}

const WireTable: React.FC<IWireTableProps> = ({
  extraItens,
  goToExtraItens,
  isGeneratingPdf = false
}) => {
  const wireTypesState = useSelector(
    (appState: ApplicationState) => appState.fabrication.annealedWireTypesState
  );

  const getDataTable = (): FabricationCheckoutWireTableDataSource[] => {
    const dataTable: FabricationCheckoutWireTableDataSource[] = [];

    const getAnnealedWire = (wireTypeId?: string) => {
      const wireType = wireTypesState?.wireTypes?.find(
        (w) => w.id === wireTypeId
      );
      return wireType;
    };

    const getWeightLabel = (quantityBy?: EProvideWireQuantityTypes.WEIGHT) => {
      return quantityBy === EProvideWireQuantityTypes.WEIGHT
        ? 'Peso do arame'
        : ' - ';
    };
    extraItens.annealedWires
      .filter((wireItem) => wireItem.annealedWireTypeId)
      .forEach((wireItem, idx) => {
        const wireType = getAnnealedWire(wireItem.annealedWireTypeId);

        dataTable.push({
          key: idx,
          wireType: wireType ? `${wireType.description}` : ' - ',
          quantityBy:
            wireItem.provideQuantityBy === EProvideWireQuantityTypes.PERCENTAGE
              ? 'Porcentagem %'
              : getWeightLabel(wireItem.provideQuantityBy),
          wireWeight: (wireItem.weight && `${wireItem.weight} kg`) || ' - ',
          percentage:
            (wireItem.percentage && `${wireItem.percentage} %`) || ' - '
        });
      });

    return dataTable;
  };

  const [fabricationWireData] = useState<
    FabricationCheckoutWireTableDataSource[]
  >(getDataTable());

  const getColumns = () => {
    const columns = [
      {
        title: 'Tipo de arame',
        dataIndex: 'wireType',
        render: (text: string) => <span>{text || ' - '}</span>
      },
      {
        title: 'Fornecer quantidade por:',
        dataIndex: 'quantityBy',
        render: (text: string) => <span>{text || ' - '}</span>
      },
      {
        title: 'Peso do arame',
        dataIndex: 'wireWeight',
        render: (text: string) => <span>{text || ' - '}</span>
      },
      {
        title: 'Porcentagem',
        dataIndex: 'percentage',
        render: (text: string) => <span>{text || ' - '}</span>
      }
    ];

    return columns;
  };

  return (
    <CheckoutContainer>
      {!isGeneratingPdf && (
        <CheckoutTableHeader
          title="Arame recozido"
          onEditClick={goToExtraItens}
        />
      )}

      <TableContainer>
        <HefestoTable
          columns={getColumns()}
          dataSource={fabricationWireData}
          pagination={false}
          scroll={{
            x: 'max-content'
          }}
        />
      </TableContainer>
    </CheckoutContainer>
  );
};

export default WireTable;
